import {isTagValueStructuredTableColumn} from 'notebook/structured-tables/columns/TypePredicates';
import {StructuredTableColumn} from 'notebook/structured-tables/StructuredTableConstants';

/**
 * Returns true if the StructuredTableColumn should be treated as a read only column.
 * This includes read only, locked, computed, and snapshot columns.
 */
export default function isReadOnly(column: StructuredTableColumn): boolean {
  return column.isProtected || !isUserChangeable(column);
}

/**
 * Returns true if the StructuredTableColumn can be changed in the UI by a user.
 * Notably, this still returns true for locked columns because those are still "changeable" if the prefilled
 * value in the column references an editable cell that is changed. Keep in sync with benchling/notebook/structured_tables/logic/column_editability.py:is_user_changeable_column
 */
export function isUserChangeable(column: StructuredTableColumn): boolean {
  return !(column.isReadOnly || isUserUnchangeableSchemaField(column));
}

/**
 * Returns true when the column is a schema field that cannot be edited directly by the user, like
 * snapshot and computed fields.
 */
function isUserUnchangeableSchemaField(column: StructuredTableColumn): boolean {
  return (
    isTagValueStructuredTableColumn(column) &&
    Boolean(
      column.schemaFieldIsComputed || column.schemaFieldIsSnapshot || column.schemaFieldIsConvertedFromLink
    )
  );
}
